export const ArrowUndoIcon2 = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.08976 7.36739C8.35577 7.09987 8.78739 7.09987 9.0534 7.36739C9.31888 7.6344 9.31888 8.06691 9.0534 8.33391L8.15679 9.23571H14.0573C16.3278 9.23571 18.1668 11.0867 18.1668 13.3679C18.1668 15.6491 16.3278 17.5001 14.0573 17.5001H9.25729C8.88032 17.5001 8.57634 17.193 8.57634 16.8162C8.57634 16.4394 8.88032 16.1323 9.25729 16.1323H14.0573C15.5739 16.1323 16.8049 14.8955 16.8049 13.3679C16.8049 11.8403 15.5739 10.6035 14.0573 10.6035H8.15679L9.0534 11.5053C9.31889 11.7723 9.31888 12.2048 9.0534 12.4718C8.78739 12.7394 8.35576 12.7394 8.08976 12.4718L6.03261 10.4029C5.76712 10.1359 5.76712 9.70336 6.03261 9.43636L8.08976 7.36739Z"
      />
    </svg>
  );
};
